import { ProgressNoteKind, Service } from "@/types/__generated__/union-types"

export const getProgressNoteKind = (service: Service): ProgressNoteKind => {
  return service === "ADMINISTRATIVE_REQUEST" ? "ADMINISTRATIVE" : "MEDICAL"
}
